function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var assert = require('assert');

import _ from 'lodash';

var DecisionAlternative = /*#__PURE__*/function () {
  function DecisionAlternative(a) {
    _classCallCheck(this, DecisionAlternative);

    this._childNode = null;
    this.varValues = null;
    this.logFiles = null;
    this.trajFiles = null;
    this.logPointers = null;
    this.gridPointers = null;
    this.crossGrids = null;
    this.nextDecisionNodeId = '';
    this.segmentLength = null;

    if (_.has(a, 'variables')) {
      this.varValues = a['variables'];
    }

    if (_.has(a, 'witsml_logs')) {
      this.logFiles = a['witsml_logs'];
    }

    if (_.has(a, 'witsml_trajectory')) {
      this.trajFiles = a['witsml_trajectory'];
    }

    if (_.has(a, 'hdf5_logs')) {
      this.logPointers = a['hdf5_logs'];
    }

    if (_.has(a, 'hdf5_grids')) {
      this.gridPointers = a['hdf5_grids'];
    }

    if (_.has(a, 'cross_grids')) {
      this.crossGrids = a['cross_grids'];
    }

    if (_.has(a, 'next_decision')) {
      this.nextDecisionNodeId = a['next_decision'];
    }

    if (_.has(a, 'segment_length')) {
      this.segmentLength = a['segment_length'];
    }
  }

  _createClass(DecisionAlternative, [{
    key: "getChildNode",
    value: function getChildNode() {
      return this._childNode;
    }
  }, {
    key: "setChildNode",
    value: function setChildNode(child) {
      assert(this._childNode == null, 'ERROR: trying to overwrite child node of DecisionAlternative');
      this._childNode = child;
    }
  }]);

  return DecisionAlternative;
}();

export var DecisionNode = /*#__PURE__*/function () {
  function DecisionNode(json) {
    _classCallCheck(this, DecisionNode);

    this.description = null;
    this.comment = null;
    this.MDposition = null;
    this._parentVarObj = {};
    this.parentVariables = {};
    this.decisionId = null; //this._parentVarLogs = [];
    //this.priorLogFiles = [];

    this._parentNode = null;
    this._childNodes = [];
    this.alternatives = [];

    if (_.has(json, 'decision_id')) {
      this.decisionId = _.get(json, 'decision_id', '');
    }

    if (_.has(json, 'prior_segments')) {
      var priorSeg = json['prior_segments'];
      this._parentVarObj = _.get(priorSeg, 'variables', {}); //this._parentVarLogs = _.get(priorSeg, 'witsml_logs', []);
    } //for (let i = 0; i < this._parentVarLogs.length; i++) {
    //    this.priorLogFiles.push(this._parentVarLogs[i]);
    //}


    _.forOwn(this._parentVarObj, function (val, key) {
      this.parentVariables[key] = val;
    }.bind(this));

    this.description = _.get(json, 'description', 'no description');
    this.comment = _.get(json, 'comment', '');
    this.MDposition = _.get(json, 'MDposition', null);
    var alt = json['alternatives'];

    for (var i = 0; i < alt.length; i++) {
      var a = alt[i];
      var decAlt = new DecisionAlternative(a);
      this.alternatives.push(decAlt);
    }
  }

  _createClass(DecisionNode, [{
    key: "_findAlternativeUsingDecisionId",
    value: function _findAlternativeUsingDecisionId(id) {
      var decAlt = null;

      for (var i = 0; i < this.alternatives.length; i++) {
        var alternative = this.alternatives[i];

        if (alternative.nextDecisionNodeId === id) {
          decAlt = alternative;
          break;
        }
      }

      return decAlt;
    }
  }, {
    key: "_findAlternativeUsingVariables",
    value: function _findAlternativeUsingVariables(variables) {
      for (var i = 0; i < this.alternatives.length; i++) {
        var alternative = this.alternatives[i];
        var containsAll = true;
        var matchesInPrevSegs = 0;
        var matchesInAlternatives = 0;

        _.forOwn(variables, function (valX, key) {
          var val = typeof valX === 'string' || valX instanceof String ? valX.replace("+", "") : valX;

          if (_.has(alternative.varValues, key)) {
            var altValX = alternative.varValues[key];
            var altVal = typeof altValX === 'string' || altValX instanceof String ? altValX.replace("+", "") : altValX;

            if (altVal == val) {
              matchesInAlternatives++;
            } else {
              containsAll = false;
            }
          } else if (_.has(this.parentVariables, key)) {
            var parentValX = this.parentVariables[key];
            var parentVal = typeof parentValX === 'string' || parentValX instanceof String ? parentValX.replace("+", "") : parentValX;

            if (parentVal == val) {
              matchesInPrevSegs++;
            } else {
              containsAll = false;
            }
          } else {
            containsAll = false;
          }
        }.bind(this));

        if (containsAll && matchesInAlternatives > 0) {
          return alternative;
        }
      }

      return null;
    }
  }, {
    key: "getChildForSetOfVariables",
    value: function getChildForSetOfVariables(variables) {
      var decAlt = this._findAlternativeUsingVariables(variables);

      if (decAlt != null) {
        return decAlt.getChildNode();
      }

      return null;
    }
  }, {
    key: "getLogsForSetOfVariables",
    value: function getLogsForSetOfVariables(variables) {
      var decAlt = this._findAlternativeUsingVariables(variables);

      if (decAlt != null) {
        return decAlt.logFiles;
      }

      return null;
    }
  }, {
    key: "getTrajectoriesForSetOfVariables",
    value: function getTrajectoriesForSetOfVariables(variables) {
      var decAlt = this._findAlternativeUsingVariables(variables);

      if (decAlt != null) {
        return decAlt.trajFiles;
      }

      return null;
    }
  }, {
    key: "getGridsForSetOfVariables",
    value: function getGridsForSetOfVariables(variables) {
      var decAlt = this._findAlternativeUsingVariables(variables);

      if (decAlt != null) {
        return decAlt.gridPointers;
      }

      return null;
    }
  }, {
    key: "getSegmentLengthForSetOfVariables",
    value: function getSegmentLengthForSetOfVariables(variables) {
      var decAlt = this._findAlternativeUsingVariables(variables);

      if (decAlt != null) {
        return decAlt.segmentLength;
      }

      return null;
    }
  }, {
    key: "isAValidParentTo",
    value: function isAValidParentTo(child) {
      var decAlt = this._findAlternativeUsingDecisionId(child.decisionId); // check via variable names and values (old method)


      if (decAlt == null) {
        decAlt = this._findAlternativeUsingVariables(child.parentVariables);
      }

      if (decAlt != null) {
        decAlt.setChildNode(child);
      }

      return decAlt != null;
    }
  }, {
    key: "addChildNode",
    value: function addChildNode(child) {
      this._childNodes.push(child);
    }
  }, {
    key: "setParentNode",
    value: function setParentNode(parent) {
      assert(this._parentNode == null, 'ERROR: trying to owerwrite parent node');
      this._parentNode = parent;
    }
  }, {
    key: "getParentNode",
    value: function getParentNode() {
      return this._parentNode;
    }
  }, {
    key: "getMDposition",
    value: function getMDposition() {
      return this.MDposition;
    }
  }, {
    key: "rebuildParentVariablesInChildNodes",
    value: function rebuildParentVariablesInChildNodes() {
      if (this._parentNode != null) {
        _.forOwn(this._parentNode.parentVariables, function (val, key) {
          this.parentVariables[key] = Number(val);
        }.bind(this));

        var parentAlt = this._parentNode._findAlternativeUsingDecisionId(this.decisionId);

        if (parentAlt != null) {
          _.forOwn(parentAlt.varValues, function (val, key) {
            this.parentVariables[key] = Number(val);
          }.bind(this));
        }
      } // recursive call on children


      this._childNodes.forEach(function (childNode) {
        childNode.rebuildParentVariablesInChildNodes();
      });
    }
  }]);

  return DecisionNode;
}();